import { generatePath } from "@routes/utils";
import type { IExtractParams } from "@routes/types";

const pathBase = `/academic-groups/`;
const pathById = `${pathBase}:academicGroupId/`;
const memberPath = `${pathById}members/`;
const batchMemberPath = `${memberPath}batch/`;

export type IAcademicGroupPathParams = IExtractParams<typeof pathById>;

export const academicGroups = {
  getAll: () => generatePath(pathBase, null),
  post: () => generatePath(pathBase, null),
  get: (param: IAcademicGroupPathParams) => generatePath(pathById, param),
  put: (param: IAcademicGroupPathParams) => generatePath(pathById, param),
  patch: (param: IAcademicGroupPathParams) => generatePath(pathById, param),
  delete: (param: IAcademicGroupPathParams) => generatePath(pathById, param),
  member: {
    getAll: (param: IAcademicGroupPathParams) =>
      generatePath(memberPath, param),
    post: (param: IAcademicGroupPathParams) => generatePath(memberPath, param),
    postBatch: (param: IAcademicGroupPathParams) =>
      generatePath(batchMemberPath, param),
  },
};
